<template>
    <div class="calculadora" v-if="showCalc && showCalcProp">
        <div class="calculadora-header">
            <h4>Cálculo de Data</h4>
        </div>       
        <v-form ref="form">
            <v-container class="ma-0 pa-0">     
                <v-menu
                    ref="menu"
                    attach="body"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
            
                    <template v-slot:activator="{ on, attrs }">
                        <div class="linha-dados">
                            <datePicker                         
                                    v-model="dateFormatado"                       
                                    label="Data inicial" 
                                    v-mask="maskData"                        
                                    v-bind="attrs"
                                    @input="date = parseDate(dateFormatado); validaCampos()"
                                    v-on="on"   
                                    ref="DataCalc"                                              
                                    :show-current="false"
                                    dense
                                    />   
                        </div>                 
                    </template>  

                </v-menu>

            <div >

                <div class="linha-dados">
                <v-select
                    v-model="tipoCalculo"
                    :items="tiposCalculo"
                    item-text="text"
                    item-value="value"
                    label="Tipo de cálculo"
                    dense
                    hide-details
                    class="my-2 ma-0 pa-0"
                ></v-select>
                </div>

                <div class="linha-dados">
                <v-text-field
                    v-model="qtdDias"
                    :label="tipoCalculoLabel"
                    required
                    type="number"
                    maxlength="3"
                    min="0"
                    @input="validaCampos()"
                    dense
                    hide-details
                    class="my-2 ma-0 pa-0"
                ></v-text-field>
                </div>
                

                <div class="linha-dados">
                    <v-text-field
                        v-model="dataFutura"
                        readonly
                        aria-disabled="true"
                        label="Próxima"
                        dense
                        hide-details
                        class="my-2 ma-0 pa-0"                      
                    ></v-text-field>
                </div>

                <div class="calc-actions">
                    <v-btn
                    color="primary"
                    dark
                    class="calc-btn primary-btn"
                    @click="calcular()"
                    >
                    CALCULAR
                    </v-btn>
                    <v-btn
                    color="grey darken-4"
                    dark
                    class="calc-btn secondary-btn"
                    @click="btnLimpar()"
                    >
                    LIMPAR
                    </v-btn>
                </div>
            </div>
            
        </v-container>
            </v-form>
    </div>
</template>

<style>
.calculadora {
  width: 300px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: auto; /* permite expandir conforme conteúdo */
  max-height: none; /* permitir que a página principal faça a rolagem */
  overflow-y: visible; /* deixar a rolagem para a página principal */
  padding-bottom: 20px;
  padding-left: 0;
  padding-right: 0;
}

.calculadora-header { 
  width: 100%;
  background-color: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
}

.calculadora h4 {
  text-align: center; /* Alinha o texto à esquerda */
  font-size: 17px;
  font-weight: bold;
  padding: 10px 15px; /* Adiciona padding para afastar das bordas */
  margin: 0; /* Remove margens negativas */
  border-bottom: 1px solid #e0e0e0; /* Adiciona borda inferior */
  width: 100%; /* Garante que o título ocupe toda a largura */
}

.calculadora .v-input__slot {
  background: #fff;
  width: 275px;
  height: 45px;
  margin-bottom: 4px;
  margin-top: 2px;
}

.calculadora .v-text-field__slot {
  background: #fff;
}

.calculadora .error {
    margin: 5px 10px 10px 10px !important;
    height: 24px;
    width: 25px; 
}

.calculadora .v-messages {
    display: none !important;
}

.calculadora .v-text-field {
    padding: 15 !important;
}

.calc-actions {
  display:flex;
  flex-direction: column;
  gap:8px;
  width: 100%;
  align-items: center;
  padding-top: 10px;
}
.calc-btn {
  height: 40px;
  width: 270px;
  border-radius: 0;
  font-weight: normal;
  letter-spacing: 0.5px;
}
.primary-btn {
  background-color: #1976d2 !important; /* cor padrão azul do v-btn */
}
.secondary-btn {
  background-color: #424242 !important; /* cinza escuro */
}

/* Fix: garantir que o container da calculadora não seja cortado quando a página for rolada */
.calculadora {
  position: relative;
}
</style>

<script>
import moment from "moment";
import util from "../plugins/util";
import regularidadeFiscTrabService from "../services/regularidadeFiscTrabService";
export default {
    props: {
       showCalcProp: Boolean,
       LimpaCampos: Object
    },
 mixins: [util],  
    data: function () {
        return {
            date: '',
            dateFormatado: '',
            qtdDias: null,
            clickable: true,
            dataFutura: '',
            showCalc: true,
            tiposCalculo: [
                { text: 'Dias Corridos', value: 'corridos' },
                { text: 'Dias Úteis', value: 'uteis' },
                { text: 'Meses (data a data)', value: 'meses' }
            ],
            tipoCalculo: 'corridos'
        }
    },

    methods: {
        limpaForm () {            
             for (field in this.fields) this.fields[field] = ""            
         },

        formatDate:function  (date) {     

        if (!date) return null

        var arr= date.split('-'),
                year = arr[0],
                month =  arr[1],
                day=  arr[2];
        return `${day}/${month}/${year}`
        },
        parseDate:function  (date) {
            if (!date) return null
            // aceita formatos: 'DD/MM/YYYY' ou 'YYYY-MM-DD'
            if (date.indexOf('-') !== -1) {
                // assume já está em ISO
                return date;
            }
            var arr = date.split('/'),
                        day = arr[0],
                        month =  arr[1],
                        year =  arr[2];
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        calcular() {
            var setQtdDias = parseInt(this.qtdDias, 10) || 0;
            // determina data ISO (YYYY-MM-DD) a partir de this.date (quando disponível) ou dateFormatado
            var iso = this.date;
            if (!iso && this.dateFormatado) {
                if (this.dateFormatado.indexOf('/') !== -1) {
                    // form: DD/MM/YYYY
                    var p = this.dateFormatado.split('/');
                    if (p.length === 3) iso = `${p[2]}-${p[1].padStart(2,'0')}-${p[0].padStart(2,'0')}`;
                } else if (this.dateFormatado.indexOf('-') !== -1) {
                    iso = this.dateFormatado;
                }
            }
            if (!iso) return;
            var base = moment(iso, "YYYY-MM-DD");

            // Se tipo 'uteis' faz chamada ao backend para considerar feriados oficiais
            if (this.tipoCalculo === 'uteis') {
                let payload = {
                    dataInicial: iso,
                    quantidade: setQtdDias,
                    tipo: 'uteis'
                };
                // usa o service importado diretamente
                regularidadeFiscTrabService.calcularData(payload)
                    .then(resp => {
                        if (resp && resp.data && resp.data.data) {
                            this.dataFutura = resp.data.data;
                        }
                    }).catch(() => {
                        if (this.$root && this.$root.$toasted) this.$root.$toasted.error('Erro ao calcular dias úteis');
                        else if (this.$toasted) this.$toasted.error('Erro ao calcular dias úteis');
                    });
                return;
            }

            var dataFutura;
            if (this.tipoCalculo === 'corridos') {
                dataFutura = base.clone().add(setQtdDias, 'days');
            } else if (this.tipoCalculo === 'meses') {
                dataFutura = base.clone().add(setQtdDias, 'months');
            } else {
                dataFutura = base.clone().add(setQtdDias, 'days');
            }

            var setDia = dataFutura.format('DD');
            var setMesa = dataFutura.format('MM');
            var setAno = dataFutura.format('YYYY');

            var retDataFutura = setDia + '/' + setMesa + '/' + setAno;
            this.dataFutura = retDataFutura;          
        },
        validaCampos() {
            var setQtdDias = this.qtdDias;
            var calend = this.dateFormatado;
            if (calend && setQtdDias !== null && setQtdDias !== '' && !isNaN(setQtdDias)) {
                this.clickable = false;
            } else {
                this.clickable = true;
            }
        },
        btnFechar() {
            this.$refs.form.reset();
            this.showCalc = false
          
        }
        ,
        btnLimpar() {
            this.$refs.form.reset();
            this.qtdDias = null;
            this.dataFutura = '';
            this.tipoCalculo = 'corridos';
            this.clickable = true;
        }
        
    },
  
    computed: {
        computeddateFormatado () {
            return this.formatDate(this.date)
        },
        tipoCalculoLabel() {
            switch (this.tipoCalculo) {
                case 'corridos': return 'Quantidade de dias';
                case 'uteis': return 'Quantidade de dias úteis';
                case 'meses': return 'Quantidade de meses';
                default: return 'Quantidade';
            }
        },
    },

    watch: {
        date (val) {
            this.dateFormatado = this.formatDate(this.date)
        },   

        LimpaCampos: function(newValue,OldValue) { // watch it
            if(this.showCalc){
                this.$refs.form.reset();
            }
         this.showCalc = true;
          
        }           

    },

}
</script>